import dayjs, { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import styled from "styled-components";
import get from "lodash/get";
import { CalendarIcon } from "../../../../icons";
import { IconButton } from "src/components/ui/baseButton";

const StyledTextField = styled(TextField)`
  fieldset {
    border: 0;
  }
  input {
    font-size: 12px;
    font-weight: 600;
    width: 50px;
    padding: 8px;
    padding-right: 14px;
    cursor: pointer;
  }
`;

const Wrapped = styled("div").attrs({
  className:
    "rounded-xl border border-quinary flex items-center text-xs font-semibold w-fit h-full",
})``;

const DatePickerYear = (props) => {
  const { yearDate } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Wrapped>
        <DatePicker
          inputFormat="YYYY"
          views={["year"]}
          maxDate={dayjs(new Date())}
          //   PaperProps={{
          //     sx: {
          //       "& .MuiPickersDay-root": {
          //         "&.Mui-selected": {
          //           backgroundColor: "var(--color-calendar) !important",
          //           "&:hover": {
          //             background: "var(--color-calendar) !important",
          //           },
          //         },
          //         "&:hover": {
          //           background: "var(--color-calendar-hover) !important",
          //         },
          //       },

          //       "& .PrivatePickersYear-root": {
          //         button: {
          //           "&:hover": {
          //             backgroundColor: "var(--color-calendar-hover) !important",
          //           },
          //           "&.Mui-selected": {
          //             backgroundColor: "var(--color-calendar) !important",
          //             "&:hover": {
          //               backgroundColor: "var(--color-calendar) !important",
          //             },
          //           },
          //         },
          //       },
          //     },
          //   }}
          renderInput={(params) => {
            const onOpenDialog = params?.disabled
              ? () => {}
              : get(
                  params,
                  "InputProps.endAdornment.props.children.props.onClick",
                  () => {}
                );

            return (
              <StyledTextField
                {...params}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={onOpenDialog}
                      className={`absolute right-1 top-1 btn-ghost btn-circle btn-xs hover:bg-transparent`}
                    >
                      <img src={CalendarIcon} alt="calendarIcon" />
                    </IconButton>
                  ),
                }}
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                  style: {
                    userSelect: "none",
                  },
                }}
                sx={{
                  input: {
                    textAlign: "center",
                    color: "#5ABC99 ",
                  },
                }}
                onClick={onOpenDialog}
              />
            );
          }}
          value={yearDate.value}
          onChange={(newValue) => {
            const date = dayjs(newValue);
            yearDate.setValue(date);
          }}
        />
      </Wrapped>
    </LocalizationProvider>
  );
};

export default DatePickerYear;
